/**
 * Navigation menus shared by the header (desktop bar + mobile drawer) and
 * the mobile-drawer's resources section. Keeping these in one file makes
 * sure the desktop and mobile menus stay in sync as we add pages.
 */

import type { NavItem } from "@/types";

/** Top-level pages that appear in the main header. */
export const NAV_ITEMS: NavItem[] = [
  { href: "/", label: "Home" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/blog", label: "Blog" },
  { href: "/about", label: "About" },
  { href: "/careers", label: "Careers" },
];

/** Resource / legal links rendered in the mobile drawer footer. */
export const NAV_RESOURCES: NavItem[] = [
  { href: "/blog", label: "Blog" },
  { href: "/#faq", label: "FAQ" },
  { href: "/careers", label: "Hire a Dev" },
  { href: "/privacy-policy", label: "Privacy Policy" },
  { href: "/terms-of-service", label: "Terms of Service" },
];
